'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _GenericSettings = require('redux/modules/GenericSettings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CannedRules = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CannedRules, _Component);

  function CannedRules() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CannedRules);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CannedRules.__proto__ || (0, _getPrototypeOf2.default)(CannedRules)).call.apply(_ref, [this].concat(args))), _this), _this.onAdd = function (e) {
      e.preventDefault();
      var rule = {
        id: _uuid2.default.v4(),
        name: '',
        description: '',
        deleted: false
      };
      _this.addCannedRule(rule);
    }, _this.onRemove = function (id) {
      _this.deleteCannedRule(id);
    }, _this.onEdit = function (columnIndex, rowData) {
      if (_this.props.editCannedRule) _this.props.editCannedRule(columnIndex, rowData);
    }, _this.onConfirmEdit = function (value, rowData, property) {
      if (_this.props.confirmEditCannedRule) {
        _this.props.confirmEditCannedRule(value, rowData, property);
      }
    }, _this.onCannedRulesChange = function (rows) {
      if (_this.props.changeCannedRulesProperty) {
        _this.props.changeCannedRulesProperty('cannedRules', rows);
      }
    }, _this.deleteCannedRule = function (id) {
      if (_this.props.deleteCannedRule) _this.props.deleteCannedRule(id);
    }, _this.addCannedRule = function (row) {
      if (_this.props.addCannedRule) _this.props.addCannedRule(row);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CannedRules, [{
    key: '_getColumns',
    value: function _getColumns() {
      var _this2 = this;

      var styles = require('./CannedRules.scss');

      return [{
        property: 'name',
        header: {
          label: 'Name'
        },
        editable: true,
        visible: true,
        width: 400
      }, {
        property: 'description',
        header: {
          label: 'Description'
        },
        editable: true,
        visible: true
      }, {
        props: {
          style: {
            width: 100,
            textAlign: 'center'
          }
        },
        cell: {
          format: function format(value, _ref2) {
            var rowData = _ref2.rowData;
            return _react2.default.createElement(_components.EnterpriseIcons.Trash, {
              fill: '#005D8C',
              width: 40,
              height: 40,
              className: styles.trashItem,
              onClick: function onClick() {
                return _this2.onRemove(rowData.id);
              }
            });
          }
        }
      }];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cannedRules = _props.cannedRules;

      var columns = this._getColumns();
      var styles = require('./CannedRules.scss');

      return _react2.default.createElement(
        _components.EnterpriseGrid.Row,
        { className: (0, _classnames2.default)(className, styles.root) },
        _react2.default.createElement(
          _components.EnterpriseGrid.Col,
          { xs: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'span',
              { className: styles.headerText },
              'CANNED RULES'
            )
          )
        ),
        _react2.default.createElement(
          _components.EnterpriseGrid.Col,
          { xs: 12 },
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            { className: styles.body },
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12 },
              _react2.default.createElement(_components.EnterpriseTable, {
                rows: cannedRules || [],
                rowKey: 'id',
                columns: columns,
                tableWidth: '100%',
                tableHeight: 600,
                pagination: { page: 1, perPage: 10 },
                addAction: true,
                onAdd: this.onAdd,
                onPropertyChange: this.onCannedRulesChange,
                onDelete: this.onRemove,
                onEdit: this.onEdit,
                onConfirmEdit: this.onConfirmEdit
              })
            )
          )
        )
      );
    }
  }]);
  return CannedRules;
}(_react.Component), _class.preload = function () {
  return [[_GenericSettings.fetchGenericSettingsSaga, _GenericSettings.getGenericSettings.base()]];
}, _class.propTypes = {
  cannedRules: _react.PropTypes.array,
  changeCannedRulesProperty: _react.PropTypes.func,
  getGenericSettings: _react.PropTypes.func,
  deleteCannedRule: _react.PropTypes.func,
  addCannedRule: _react.PropTypes.func,
  editCannedRule: _react.PropTypes.func,
  confirmEditCannedRule: _react.PropTypes.func,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  cannedRules: []
}, _temp2);


var mapStateToProps = function mapStateToProps(state) {
  var genericSettings = state.genericSettings;

  var _ref3 = genericSettings || {},
      cannedRules = _ref3.cannedRules;

  var _ref4 = cannedRules || {},
      _ref4$temp = _ref4.temp,
      temp = _ref4$temp === undefined ? [] : _ref4$temp;

  return { cannedRules: temp };
};

var getActions = function getActions() {
  return {
    getGenericSettings: _GenericSettings.getGenericSettings.base,
    changeCannedRulesProperty: _GenericSettings.changeCannedRulesProperty,
    addCannedRule: _GenericSettings.addCannedRule,
    deleteCannedRule: _GenericSettings.deleteCannedRule,
    editCannedRule: _GenericSettings.editCannedRule,
    confirmEditCannedRule: _GenericSettings.confirmEditCannedRule
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, getActions())(CannedRules);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CannedRules/CannedRules.jsx
// module id = 1449
// module chunks = 0